import product1 from "../../img/default/image.jpeg";
import product2 from "../../img/price_1OoN4GJPJhBGLCn4wRZCGIhh/image.jpeg";

// {
//   ID: 3,
//   productName: "Macbook Pro 2022 (M1)",
//   price: 35.0,
//   productImage: "https://construirewebsiteproducts.s3.eu-west-1.amazonaws.com/WebsiteImages/Free-hd-blurred-wallpaper.jpg",
//   stripeID: "price_1OuuHfJPJhBGLCn4gkCqg5oJ",
//   description: "je taime pas dsl, lamour ne sachete pas",
// },
// {
//   ID: 4,
//   productName: "Macbook Pro 2022 (M1)",
//   price: 25.0,
//   productImage: "https://construirewebsiteproducts.s3.eu-west-1.amazonaws.com/WebsiteImages/Free-hd-blurred-wallpaper.jpg",
//   stripeID: "price_1OoN4eJPJhBGLCn4dubYwveS",
//   description: "fun in the cloud",
// },
// {
//   ID: 5,
//   productName: "Macbook Pro 2022 (M1)",
//   price: 1999.0,
//   productImage: "https://construirewebsiteproducts.s3.eu-west-1.amazonaws.com/WebsiteImages/Free-hd-blurred-wallpaper.jpg",
//   stripeID: "price_1OoN4GJPJhBGLCn4wRZCGIhh",
//   description: "get to know me please",
// },

export const Products = [
  {
    ID: 1,
    productName: "IPhone",
    price: 25.0,
    productImage: product1,
    stripeID: "price_1OoN4eJPJhBGLCn4dubYwveS",
    description: "oh ma je ma oooooooooooooooooooooooooooooooooh",
  },
  {
    ID: 2,
    productName: "Macbook Pro 2022 (M1)",
    price: 35.0,
    productImage: product1,
    stripeID: "price_1OuuHfJPJhBGLCn4gkCqg5oJ",
    description: "mdr lol jeux olymique a Pariiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiis",
  },

];